const links = [
  { label: "MUSIC", href: "#music" },
  { label: "ABOUT", href: "#about" },
  { label: "SOCIALS", href: "#socials" },
  { label: "SIGNUP", href: "#signup" },
];

/**
 * Vertical rail along the left edge.
 *
 * Rather than stacking glyphs with `writing-mode`, the whole bar is laid out
 * as a normal horizontal flex row and rotated -90deg about its top-right
 * corner. Letter-spacing and word gaps stay horizontal, so the spacing reads
 * evenly — the approach the reference uses.
 *
 * `row-reverse` means the DOM order below (MUSIC → SIGNUP → glyph → wordmark)
 * ends up reading top-to-bottom once rotated, with WINTERSIX at the foot.
 */
function SideNav() {
  return (
    <div className="side-nav" aria-hidden="false">
      <nav className="side-nav-bar" aria-label="Primary">
        {links.map((link) => (
          <a key={link.href} href={link.href} className="side-nav-link">
            {link.label}
          </a>
        ))}

        <img
          className="side-nav-glyph"
          src="/w6_white.png"
          alt=""
          aria-hidden="true"
          width="26"
          height="26"
          draggable={false}
        />

        <a href="#top" className="side-nav-wordmark">
          WINTERSIX
        </a>
      </nav>
    </div>
  );
}

export default SideNav;
